import React, { useState, useEffect } from 'react'
import { Panel, Progress } from 'rsuite'
import { Row, Col } from 'rsuite'
import { Icon } from 'rsuite'
import { FlexboxGrid } from 'rsuite'

export default function ProjectCost({ schema }) {
  const { Circle, Line } = Progress

  const baseStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '150px',
  }

  const titleStyle = {
    // whiteSpace: 'nowrap',
    textAlign: 'left',
  }

  const slimText = {
    fontSize: '0.666em',
    color: '#97969B',
    paddingBottom: 5,
  }

  const Card = (data, index) => {
    console.log('data => ', data, index)
    const style = {
      backgroundColor: data.data.buttonColor,
      ...baseStyle,
    }

    return (
      <Panel styles={{ paddingBottom: '20px', paddingTop: '20px' }} bordered bodyFill shaded>
        <FlexboxGrid align="middle">
          <FlexboxGrid.Item colspan={8} style={style}>
            <Icon
              icon="inbox"
              size="4x"
              style={{
                color: '#ffffff',
              }}
            />
          </FlexboxGrid.Item>

          <FlexboxGrid.Item
            colspan={16}
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            {data.dataIndex == 0 ? (
              <>
                <div style={{ padding: '10px' }}>
                  <Row style={{ marginTop: 15 }}>
                    <Col md={24} sm={24} xs={24} style={titleStyle}>
                      {/* <div style={{ minHeight: '50px' }}></div> */}
                      {data.data.displayName}
                    </Col>
                    <Col md={24} sm={24} xs={24} style={slimText}>
                      <div style={{ width: 80 }}>
                        <Circle
                          percent={parseInt(data.data.totalProject || 0)}
                          strokeColor={data.data.totalProject == '100' ? '#52c41a' : '#3385ff'}
                          status={data.data.totalProject == '100' ? 'success' : null}
                        />
                      </div>
                    </Col>
                    {/* <Col md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {data.data.totalBudget
                        ? data.data.totalBudget.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        : ''}
                    </Col> */}
                  </Row>
                </div>
              </>
            ) : (
              <>
                <div style={{ padding: '10px' }}>
                  <Row>
                    <Col md={24} sm={24} xs={24} style={titleStyle}>
                      <div style={{ minHeight: '50px' }}>{data.data.displayName}</div>
                    </Col>
                    <Col md={24} sm={24} xs={24} style={slimText}>
                      <div className="right">
                        <h4 style={{ fontWeight: 'bold' }}>{data.data.totalProject}</h4>
                        {data.data.unitProject && (
                          <h6 style={{ fontWeight: 'bold' }}>{data.data.unitProject}</h6>
                        )}
                      </div>
                    </Col>
                    <Col md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {data.data.totalBudget
                        ? data.data.totalBudget.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        : ''}
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Panel>
    )
  }

  return (
    <>
      {schema && (
        <>
          {/* {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )} */}
          <Row style={{ marginTop: 15 }}>
            {schema.value.map((data, index) => {
              // console.log('gggg => ', index)
              return (
                <Col md={6} sm={12} xs={24} key={index} align="right">
                  <Card data={data} dataIndex={index}></Card>
                </Col>
              )
            })}
          </Row>
        </>
      )}
    </>
  )
}

const settingSchema = [
  {
    projectStatusCode: '3',
    projectStatusName: 'คัดกรอง',
    displayName: 'อยู่ระหว่างกลั่นกรอง',
    totalProject: 99,
    totalBudget: 999999,
    buttonColor: '#B7CFB7',
  },
  {
    projectStatusCode: '4',
    projectStatusName: 'กลั่นกรอง',
    displayName: 'อยู่ระหว่างอนุมัติ',
    totalProject: 99,
    totalBudget: 999999,
    buttonColor: '#97C1A9',
  },
  {
    projectStatusCode: '5',
    projectStatusName: 'อนุมัติ/รอทำสัญญา',
    displayName: 'อยู่ระหว่างทำข้อตกลง',
    totalProject: 99,
    totalBudget: 999999,
    buttonColor: '#B5EAD6',
  },
  {
    projectStatusCode: '6',
    projectStatusName: 'ดำเนินการ',
    displayName: 'อยู่ระหว่างดำเนินการ',
    totalProject: 99,
    totalBudget: 999999,
    buttonColor: '#9AB7D3',
  },
]
